module.exports = __webpack_public_path__ + "img/Mom-icons_Funnel.ebd3a67e.png";